// Элемент группы переключателей фильтра

import {h} from 'preact';
import translit from '~/app/utils/translit';

/**
 * Component Properties
 */
interface FilterCheckboxesItemProps
{
	/** Имя формы */
	formName: string;
	/** Имя переключателя */
	name: string;
	/** Подпись переключателя */
	label: string;
	/** Значение переключателя */
	value: string;
	/** Выбран? */
	checked?: boolean;
	/** Отключён? */
	disabled?: boolean;
}

/**
 * Элемент группы переключателей фильтра
 */
function FilterCheckboxesItem(
	{formName, name, label, value, checked, disabled}: FilterCheckboxesItemProps,
): JSX.Element
{
	const id = `f-${formName}-${
		name.replace( /[^A-Za-z0-9_-]/g, '' )
	}-${valueToName( value )}`;
	
	return (
		<li class="checkbox">
			<input
				type="checkbox"
				name={name}
				id={id}
				value={value}
				checked={checked}
				disabled={disabled}
			/>
			<label for={id}>{label}</label>
		</li>
	);
}

/**
 * Преобразовать значение для использования в имени/ID
 */
function valueToName( value: string ): string
{
	return translit( value )
		.replace( /[ _.]/g, '-' )
		.replace( /--+/g, '-' )
		.replace( /[^A-Za-z0-9-]|^-+|-+$/g, '' );
}

/**
 * Module
 */
export {
	FilterCheckboxesItem as default,
	FilterCheckboxesItemProps,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/FilterCheckboxesItem.tsx